import { BigButton } from "./BigButton"
import React from "react"
import Button from "../Button/Button"

export function ConfirmOrCancel({
                                  onCancel,
                                  onConfirm,
                                  leftBlock,
                                  disabled
                                }) {
  return (
    <div className='w-full flex flex-row justify-between'>
      <div>{leftBlock}</div>
      <div className='flex flex-row'>
        <Button onClick={onCancel} type="outlined" size="md" width="w-max">Cancel</Button>
        <div className='mr-3'></div>
        <Button onClick={onConfirm} size="md" width="w-max" disabled={disabled}>Confirm</Button>
      </div>
    </div>
  )
}
